import {ReactElement} from 'react'
import {Button} from '@material-ui/core'
import {Trans} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {ModalContainer} from '../ModalContainer'
import messages from '../../../../../assets/messages'
import {useStyles} from './styles'

const none = () => null

function DepositMethodVerificationInReviewModal(): ReactElement {
  const classes = useStyles()
  const history = useHistory()

  const handleGoToAccountsClick = () => history.push('/')

  return (
    <ModalContainer isOpen onClose={none}>
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.title}>
            <Trans {...messages.depositMethodVerificationInProgress} />
          </div>
        </div>
        <div className={classes.body}>
          <div className={classes.text}>
            <Trans {...messages.youCantMakeAnotherWithdrawalAttempt} />
          </div>
          <div className={classes.text}>
            <Trans {...messages.youWillReceiveEmailNotificationOnceWithdrawal} />
          </div>
          <Button
            fullWidth
            className={classes.button}
            color='primary'
            variant='contained'
            onClick={handleGoToAccountsClick}
          >
            <Trans {...messages.goBackToAccounts} />
          </Button>
        </div>
      </div>
    </ModalContainer>
  )
}

export {DepositMethodVerificationInReviewModal}
